import axios from "axios";
import { handleHttpErrors } from "../../../modules/http";

const initialState = {};

export const editCaregiverReducer = (state = initialState, action) => {
  return state;
};

const editCaregiver = (formData) => (dispatch, getState) => {
  return axios
    .post(`/api/participant/user/edit`, formData)
    .then(({ data }) => {
      return Promise.resolve({
        message: "Caregiver edited successfully",
        caregiver: { userId: data?.id, ugnxId: data?.ugnxId },
      });
    })
    .catch((error) => {
      return handleHttpErrors(error.request?.status, {
        default: error.response?.data,
      });
    });
};

export const mapDispatchToProps = {
  editCaregiver,
};
